import { render, staticRenderFns } from "./ButtonPrev.vue?vue&type=template&id=6654bf6d"
import script from "./ButtonPrev.vue?vue&type=script&lang=js"
export * from "./ButtonPrev.vue?vue&type=script&lang=js"
import style0 from "./ButtonPrev.vue?vue&type=style&index=0&id=6654bf6d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports